import React from "react";
import { Link, withRouter } from 'react-router-dom';
const DeviceCanSell=()=>{
    
   return( 
   <div className="container p-3">
    <div className="container-3 p-4 vh-70">
        <span style={{fontSize:20, fontFamily:600}}>Devcie we can buy:</span>
        <br></br><br></br>
        <span style={{fontSize:15, fontFamily:400}}>cash4device.ca  buys many types of Apple devices, Apple Macbooks. All of the items we buy can be found on <Link to="/SellADevice"><u>sell a device to us.</u></Link></span>
        <br></br><br></br>
        <span style={{fontSize:15, fontFamily:400}}>If your exact model does not appear on our website that means we no longer make instant offers for that item. However we may still be interested in that items, you can submit the form in <Link to="/otherDevice"><u>Other Devices section.</u></Link> to see if we can make an offer to you for that devices.  If we receive an item that is not in our catalog or we approved for by offering the quote, we will not be able to honor the price quoted in your offer. A counter offer will be provided, or if we cannot take the item, we will either ship it back to you for the nominal shipping cost, or recycle it responsibly upon your confirmation</span>

    </div>                    
                               
</div>
)
}
export default DeviceCanSell;